import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../../../services/wordpress.service';
import { ShowreelHighlightCard, WhatWeHandleCard } from '../../../models/service.model';

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.scss']
})
export class ProductionComponent implements OnInit {
  showMoreVideos = false;

  showreelHighlights: ShowreelHighlightCard[] = [];
  showreelLoading = true;
  showreelError: string | null = null;
  showreelSkeletonItems = Array.from({ length: 3 });

  whatWeHandleItems: WhatWeHandleCard[] = [];
  whatWeHandleLoading = true;
  whatWeHandleError: string | null = null;
  whatWeHandleSkeletonItems = Array.from({ length: 13 });

  constructor(private wordpressService: WordpressService) { }

  ngOnInit(): void {
    this.loadShowreelHighlights();
    this.loadWhatWeHandle();
  }

  private loadWhatWeHandle(): void {
    this.wordpressService.getWhatWeHandle().subscribe({
      next: items => {
        this.whatWeHandleItems = items;
        this.whatWeHandleLoading = false;
      },
      error: err => {
        this.whatWeHandleError = this.formatError(err, 'Unable to fetch What We Handle content from WordPress.');
        this.whatWeHandleLoading = false;
      }
    });
  }

  trackByWhatWeHandle(index: number, item: WhatWeHandleCard): number {
    return item.id;
  }

  private loadShowreelHighlights(): void {
    this.wordpressService.getShowreelHighlights().subscribe({
      next: items => {
        this.showreelHighlights = items;
        this.showreelLoading = false;
      },
      error: err => {
        this.showreelError = this.formatError(err, 'Unable to fetch showreel highlights from WordPress.');
        this.showreelLoading = false;
      }
    });
  }

  trackByShowreelHighlight(index: number, item: ShowreelHighlightCard): number {
    return item.id;
  }

  private formatError(err: any, fallback: string): string {
    if (err?.status) {
      return `${err.status} ${err.statusText || 'Error'}${err.error?.message ? ' - ' + err.error.message : ''}`;
    }

    return err?.message || fallback;
  }

}
